namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmSegmentBudovy extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmSegmentBudovyReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmSegmentBudovyObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmSegmentBudovyObj());
            this.detailObj.createBase({
                contentName: "detailAdmSegmentBudovy",
                contentCaption: "jres:33001063", //RC 33001063 : Segment budovy
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmSegmentBudovy", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmSegmentBudovyObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmSegmentBudovyReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return `${this.data.segment_naz}`
        }

        setSxsDetail(): string {
            return `${this.data.ico}#${this.data.budova_kod}#${this.data.segment_kod}#`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmSegmentBudovySaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord
            //data.NewRecord = this.options.newRecord;
            //if (data.NewRecord == false) {
            //    if (data.ico && data.budova_kod) {
            //        if (data.aktivita != 100) {
            //            this.cnt.isl.AdmSegmentBudovy.checkSpojeniMajetek({ ico: data.ico, budova_kod: data.budova_kod }).getData().then((result) => {
            //                if (result == true) {
            //                    this.cnt.dialogs.confirmDangerous("jres:33000257", "jres:33001058").on("yes", () => { //RC 33001058 : Měníte aktivitu budovy, na kterém je aktivně navázán majetek. Přejete si pokračovat?
            //                        this.saveDataSpecial(data, close);
            //                    })
            //                } else
            //                    this.saveDataSpecial(data, close);
            //            })
            //        } else 
            //            this.saveDataSpecial(data, close);
            //    }
            //} else
            //    this.saveDataSpecial(data, close);
        }

        private saveDataSpecial(data: Gordic.AdmIsl.Interface.GAdmSegmentBudovySaveDto, close: boolean) {
            this.cnt.isl.AdmSegmentBudovy.upsert({ data: data }).get().then((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmSegmentBudovy", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmSegmentBudovy.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ekosico(), {
                model: "model.ico=value.ico",
                flag: this.createFlagNemenne()
            })
            this.MakeSelectField("budova_kod", Gordic.Prefabs.Select.ginsbud(), {
                model: "model.ico=value.ico;model.budova_kod=value.budova_kod",
                flag: this.createFlagNemenne(),
            });
            this.MakeField("segment_kod", {
                flag: this.createFlagNemenne()
            });
            this.MakeField("segment_naz");
            this.MakeField("poznamka");
            this.MakeField("patro");
            this.MakeField("plocha");
            this.MakeSelectField("kod_vyu", Gordic.Prefabs.Select.admGinskov(), {
                model: "model.kod_vyu=value.kod_vyu"
            })
            this.MakeSelectField("ixs_esu_uziv", Gordic.Esu.Prefabs.vyberEsu({
                typ: Gordic.Esu.Globals.Enums.TypZobrazeniKaroteka.SelectEsu,
                ModOtevreni: Gordic.Global.Enums.ModOtevreni.showModalWindow,
                Logovani: {
                    Ixp: this.setSxsDetail(),
                    DuvodHledani: Gordic.Gin.Globals.Enums.DuvodHledaniEsu.neurcen,
                    DuvodHledaniTxt: "jres:33001056", //RC 33001056 : Zadání uživatele do budovy.
                    AktZnacka: ""
                },
                FieldsToFilterpanel: [
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.Nazev,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.ObchodniJmeno,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.Ico,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.Dic,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.BuSK,
                ]
            }), {
                model: "model.ixs_esu_uziv=value.ixs_esu",
                dropdown: false
            });
            this.MakeSelectField("ixs_esu_spr", Gordic.Esu.Prefabs.vyberEsu({
                typ: Gordic.Esu.Globals.Enums.TypZobrazeniKaroteka.SelectEsu,
                ModOtevreni: Gordic.Global.Enums.ModOtevreni.showModalWindow,
                Logovani: {
                    Ixp: this.setSxsDetail(),
                    DuvodHledani: Gordic.Gin.Globals.Enums.DuvodHledaniEsu.neurcen,
                    DuvodHledaniTxt: "jres:33001057", //RC 33001057 : Zadání správce budovy
                    AktZnacka: ""
                },
                FieldsToFilterpanel: [
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.Nazev,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.ObchodniJmeno,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.Ico,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.Dic,
                    Gordic.Esu.Globals.Enums.ESUKartotekaFieldToFilter.BuSK,
                ]
            }), {
                model: "model.ixs_esu_spr=value.ixs_esu",
                dropdown: false
            });
            this.MakeSelectField("segment_druh", Gordic.Prefabs.Select.admGincsbu(), {
                model: "model.segment_druh=value.segment_druh"
            })
            this.MakeField("id_kod")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}